import { render } from "./Deleteaccount.vue?vue&type=template&id=77ef7858"
import script from "./Deleteaccount.vue?vue&type=script&lang=js"
export * from "./Deleteaccount.vue?vue&type=script&lang=js"

import "./Deleteaccount.vue?vue&type=style&index=0&id=77ef7858&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__